module.exports = __webpack_public_path__ + "pic3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic3.jpg
// module id = 1580
// module chunks = 4